exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".van-popup .van-checkbox[data-v-e951e4c2]{margin:.267rem}.page[data-v-e951e4c2]{text-align:left}", ""]);

// exports
